export default "assets/images/chateaux-logos/reysson-4aa0e6fa.png";